import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section id="inicio" className="relative min-h-screen bg-dark overflow-hidden flex items-center pt-20 pb-16 md:pt-32 md:pb-24" data-id="element-94">
      {/* Background glow effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-pink-brand/10 rounded-full blur-[120px] pointer-events-none" data-id="element-95"></div>
      <div className="absolute top-1/4 right-0 w-[400px] h-[400px] bg-green-brand/5 rounded-full blur-[100px] pointer-events-none" data-id="element-96"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-97">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-98">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-99">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading text-white leading-tight mb-6" data-id="element-100">
              Tu cuerpo no está fallando.{' '}
              <span className="text-pink-brand" data-id="element-101">
                Está esperando la proporción correcta.
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-gray-300 mb-8 max-w-2xl mx-auto lg:mx-0 font-body" data-id="element-102">
              Restaura tu equilibrio hormonal con MyoChiro-Pro: El único
              suplemento en México con la proporción fisiológica 40:1 y patente
              Caronositol®.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-8" data-id="element-103">
              <a href="#comprar" className="w-full sm:w-auto text-center bg-pink-brand hover:bg-pink-brand/90 text-white text-lg px-8 py-4 rounded-full font-bold transition-all duration-300 shadow-[0_0_20px_rgba(233,30,140,0.4)] hover:shadow-[0_0_30px_rgba(233,30,140,0.6)] hover:-translate-y-1" data-id="element-104">
                Iniciar mi equilibrio hormonal
              </a>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3 text-sm text-gray-400" data-id="element-105">
              <div className="w-12 h-[1px] bg-green-brand/50" data-id="element-106"></div>
              <p className="font-medium" data-id="element-107">
                Basado en protocolos clínicos de endocrinología reproductiva.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative order-1 lg:order-2 flex justify-center" data-id="element-108">
            <div className="relative w-full max-w-md" data-id="element-109">
              <div className="absolute inset-0 bg-pink-brand/20 blur-[60px] rounded-full" data-id="element-110"></div>
              <motion.img animate={{
              y: [0, -15, 0]
            }} transition={{
              repeat: Infinity,
              duration: 6,
              ease: 'easeInOut'
            }} src="https://cdn.shopify.com/s/files/1/0976/6528/6457/files/Image_202602012121.jpg?v=1770002507" alt="MyoChiro-Pro Suplemento" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-111" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}